import CollectionApi from 'client/api/v2/CollectionApi';

class DeviceAppStatusApi extends CollectionApi {
  constructor(systemId = '') {
    super(`/api/v2/systems/${systemId}/softwareappstatuses`, {
      skip: 0,
      limit: 50,
      filter: [{
        name: 'displayName',
        operator: 'search',
        value: '',
      }],
    });
  }

  setSystemId(systemId = '') {
    this.baseUrl = `/api/v2/systems/${systemId}/softwareappstatuses`;
  }
}

export default new DeviceAppStatusApi();
